var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2862 7.21913C13.0585 4.99147 9.44678 4.99147 7.21913 7.21913C4.99147 9.44678 4.99147 13.0585 7.21913 15.2862C9.44678 17.5138 13.0585 17.5138 15.2862 15.2862C17.5138 13.0585 17.5138 9.44678 15.2862 7.21913ZM16.381 6.12425C13.5487 3.29192 8.95658 3.29192 6.12425 6.12425C3.29192 8.95658 3.29192 13.5487 6.12425 16.381C8.95658 19.2134 13.5487 19.2134 16.381 16.381C19.2134 13.5487 19.2134 8.95658 16.381 6.12425Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2822 15.2823C15.5846 14.9799 16.0748 14.9799 16.3771 15.2823L19.7732 18.6784C20.0756 18.9807 20.0756 19.4709 19.7732 19.7733C19.4709 20.0756 18.9807 20.0756 18.6784 19.7733L15.2822 16.3771C14.9799 16.0748 14.9799 15.5846 15.2822 15.2823Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.0a598825.svg";
export { ForwardRef as ReactComponent };